import { Component, output, ChangeDetectionStrategy } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { InputComponent } from '../input/input.component';

@Component({
    selector: 'app-toggle',
    templateUrl: './toggle.component.html',
    styleUrls: ['./toggle.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ToggleComponent extends InputComponent {
    readonly toggle = output<boolean>();

    constructor() {
        super();

        if (this.readonly()) {
            this.formControl()?.disable();
        }
    }

    public onChange(event: MatSlideToggleChange) {
        this.toggle.emit(event.checked);
    }
}
